import { Reducer } from 'redux';
import ActionTypes, { TBookmarksState } from './types';

export const initialState: TBookmarksState = {
  data: null,
  loading: false,
  errors: undefined,
  loadingCsv: false,
  errorsCsv: undefined,
};


const reducer: Reducer<TBookmarksState> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_BOOKMARKS_R:
      return { ...state, loading: true, errors: '' };
    
    case ActionTypes.GET_BOOKMARKS_E:
      return { ...state, loading: false, errors: action.payload };
    
    case ActionTypes.GET_BOOKMARKS_S:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };

    case ActionTypes.GET_BOOKMARKSCSV_R:
      return { ...state, loadingCsv: true, errorsCsv: '' };

    case ActionTypes.GET_BOOKMARKSCSV_E:
      return { ...state, loadingCsv: false, errorsCsv: action.payload };

    case ActionTypes.GET_BOOKMARKSCSV_S:
      return { ...state, loadingCsv: false };

    default:
      return state;
  }
};

export { reducer as BookmarksReducer };
